import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Select } from "antd";
import { Form } from "react-bootstrap";
const { Option } = Select;
 
const BasketDropDown = ({
    formData,
    setFormData
}) => {
  const dispatch = useDispatch();
  const history = useNavigate();
 
 
  const positions = useSelector((state) => state.orders.positions);
   console.log(":positions", positions)
  const [existbasketName, setexistbasketName] = useState([]);
  const [filterbasketName, setfilterbasketName] = useState([]);
  
  useEffect(() => {
    if (positions && positions.length > 0) {
      let existbasketName = [];
      for (let i = 0; i < positions.length; i++) {
        if (positions[i].basketName) {
          var index = existbasketName.findIndex(
            (item) => item.basketName === positions[i].basketName
          );
          if (index === -1) {
            existbasketName.push({
              basketId: positions[i].basketId,
              basketName: positions[i].basketName,
            });
          }
        }
      }
      setexistbasketName(existbasketName);
      setfilterbasketName(existbasketName);
    }
  }, [positions]);

  

  const clickHandle = (e) => {
    if (e) {
      var filter = filterbasketName.filter((item) => item.basketId === e)[0];
      const value = {
        ...formData,
        BasketName: filter ? filter.basketName : e,
        basketId: e,
      };
      setFormData(value);
    }
  };

  const onSearch = (e) => {
    if (e) {
      const value = {
        ...formData,
        BasketName: e,
        basketId: "",
      };
      setFormData(value);
    }
  };
 
 
  return (
    <div className="busketList_btns position-relative">
    <Form.Group className="form-group">
    <label className="form-label">
    Strategy Name 
    </label>

    <Select
      showSearch
      style={{ width: 300, zIndex:9999 }}
      defaultValue={formData.BasketName}
      optionFilterProp="children"
      placeholder={""}
      onChange={clickHandle}
      onSearch={onSearch}
      listHeight={256}
      notFoundContent={""}
      className={""}
      value={formData.BasketName}
      getPopupContainer={() => document.getElementById('area')}
    >
      {filterbasketName &&
        filterbasketName.map((option) => (
          <Option key={option.basketId} value={option.basketId}>
            {option.basketName}
          </Option>
        ))}
    </Select>
    </Form.Group>

   
  </div>
  );
};

export default BasketDropDown;
